export default "__VITE_ASSET__B2iEDL5I__"